// extracted by mini-css-extract-plugin
module.exports = {"collection":"TagCollection_collection__2EeNT","expanded":"TagCollection_expanded__1YIME","collectionTag":"TagCollection_collectionTag__1DgyZ"};